export default __webpack_public_path__ + "static/media/transmission.6d9cb1d3.svg";